module.exports = __webpack_public_path__ + "img/314.4b0f4db8.png";